import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import GoogleMap from 'google-map-react';
import classnames from 'classnames/bind';
import NotAvailable from '../notAvailable';
import styles from './index.scss';
const cx = classnames.bind(styles);
const Marker = () => (_jsx("div", { style: {
        marginLeft: -10,
        marginTop: -10,
        backgroundColor: 'red',
        width: 20,
        height: 20,
        borderRadius: 20,
    } }));
class Map extends Component {
    static propTypes = {
        apiKey: PropTypes.string,
        apiChannel: PropTypes.string,
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
        zoom: PropTypes.number,
        streetview: PropTypes.bool,
        children: PropTypes.element,
        elmId: PropTypes.string,
        className: PropTypes.string,
    };
    static defaultProps = {
        streetview: false,
        zoom: 18,
    };
    constructor() {
        super();
        this.myRef = createRef();
        this.state = {
            streetViewAvailable: true,
        };
    }
    switchMode = ({ map, maps }) => {
        const { lat, lng, streetview } = this.props;
        if (!streetview)
            return;
        const sv = new maps.StreetViewService();
        sv.getPanorama({
            location: { lat, lng },
            radius: 50,
        }, (data, status) => {
            if (status === maps.StreetViewStatus.OK) {
                const panorama = new maps.StreetViewPanorama(this.myRef.current, {
                    position: { lat, lng },
                    pov: {
                        heading: 270,
                        pitch: 0,
                    },
                    visible: true,
                });
                panorama.setPano(data.location.pano);
                panorama.setPov({
                    heading: 270,
                    pitch: 0,
                });
                panorama.setVisible(true);
            }
            else {
                this.setState({ streetViewAvailable: false });
            }
        });
    };
    render() {
        const { children, apiKey, apiChannel, lat, lng, zoom, className, elmId, streetview, } = this.props;
        if (streetview && !this.state.streetViewAvailable) {
            return _jsx(NotAvailable, { text: 'Street View Not Available' });
        }
        const passedChildren = children || _jsx(Marker, { ...{ lat, lng } });
        return (_jsxs("div", { className: className, "data-elm-id": elmId, children: [_jsx(GoogleMap, { yesIWantToUseGoogleMapApiInternals: true, className: cx('maps'), center: {
                        lat,
                        lng,
                    }, defaultZoom: zoom, bootstrapURLKeys: {
                        client: apiKey,
                        channel: apiChannel,
                        v: 3,
                    }, options: {
                        streetViewControl: true,
                        zoomControl: true,
                        zoomControlOptions: { position: 6 },
                        draggable: true,
                        overviewMapControl: true,
                        rotateControl: true,
                        mapTypeControl: true,
                    }, onGoogleApiLoaded: this.switchMode, children: passedChildren }), streetview && (_jsx("div", { ref: this.myRef, style: {
                        position: 'absolute',
                        top: 0,
                        height: '100%',
                        width: '100%',
                    } }))] }));
    }
}
export default Map;
//# sourceMappingURL=index.js.map